import FederationTemplateConfig from "../template";
import { merge } from "lodash-es";
import Colors, { quillColors } from "./colors";
export default class NorwegianFederation extends FederationTemplateConfig {
    constructor() {
        super();
        this.logo = {
            image: require("./logo.png"),
            label: "Norges Rytterforbund",
            backgroundColor: "primary-light"
        };
        this.countryCode = "NO";
        this.locale = "nb-NO";
        this.sprites = require("./norway-sprites.svg");
        this.placeholderLogo = require("./placeholder-logo.svg");
        this.webTitle = "NRYFstevne";
        this.colors = merge(this.colors, Colors);
        this.quillColors = merge(this.quillColors, quillColors);
        this.heroBanner = merge(this.heroBanner, {
            webp: require(`./banner.webp`),
            jpeg: require(`./banner.jpg`)
        });
        this.documents = {
            paymentTermsOfService: "https://nryfstevne.helpscoutdocs.com/article/19-terms-of-use"
        };
        this.images = merge(this.images, {
            footer: require("./footer-image.svg")
        });
        this.links = merge(this.links, {
            homepage: "https://www.rytter.no/",
            news: "https://www.rytter.no/",
            rulesPage: "https://www.rytter.no/sport/reglement"
        });
    }
}
